import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import logger from "../../../util/logger";
import * as _ from "../../../util/lodash";
import React from 'react';
import PropTypes from 'prop-types';
import { Utils } from "../../../wayin-react";
import classnames from 'classnames';
import { directions, sizes } from "../../../enums";
import { Form } from 'semantic-ui-react';
import { removeProps, whitelistStyles } from "../hoc";
import { compose } from 'react-recompose';
import Checkbox, { PrivateCheckbox, isComponentDisabled } from "../checkbox-like/checkbox";
import Toggle from "../checkbox-like/toggle";
import Label from "../label";
var CHECKBOX_TYPES = ['Checkbox', 'Toggle']; // TODO: update to createComponent when custom prop validation is supported

var CheckboxGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CheckboxGroup, _React$Component);

  function CheckboxGroup() {
    var _context;

    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;

    _this.onChange = function (event, data) {
      var _context2;

      var props = _this.props;
      var selectedValues = !!data.checked ? _concatInstanceProperty(_context2 = []).call(_context2, props.selectedValues, [data.value]) : _.reject(props.selectedValues, function (value) {
        return value === data.value;
      });

      var newData = _Object$assign({}, data, {
        selectedValues: selectedValues
      });

      props.onChange(event, newData);
    };

    return _this;
  }

  var _proto = CheckboxGroup.prototype;

  _proto.render = function render() {
    // TODO use additional semantic Form props here as needed to meet styling and behavior reqs
    var props = this.props;
    var groupUIProps = {},
        controls;

    if (props.layout === directions.HORIZONTAL) {
      groupUIProps.inline = true;
    } else if (props.layout === directions.VERTICAL) {
      groupUIProps.grouped = true;
    }

    logger.warn('Children cannot be defined with "options", please choose one or the other, in CheckboxGroup', !_.isEmpty(props.options) && !_.isEmpty(React.Children.toArray(props.children)));

    if (!_.isEmpty(props.options)) {
      controls = extractControlsFromOptions(props, this.onChange);
    } else {
      controls = extractControlsFromChildren(props, this.onChange);
    }

    var fields = _mapInstanceProperty(_).call(_, controls, function (control, idx) {
      return /*#__PURE__*/React.createElement(Form.Field, {
        key: idx
      }, control);
    });

    var checkboxGroupClassnames = classnames('ck-checkbox-group', props.layout + "-spacing", props.spacing);
    return /*#__PURE__*/React.createElement("div", {
      className: checkboxGroupClassnames,
      style: props.style
    }, /*#__PURE__*/React.createElement(Form, null, props.label ? /*#__PURE__*/React.createElement(Label, {
      text: props.label
    }) : null, /*#__PURE__*/React.createElement(Form.Group, groupUIProps, fields)));
  };

  return CheckboxGroup;
}(React.Component);

CheckboxGroup.displayName = 'CheckboxGroup';
CheckboxGroup.propTypes = {
  children: checkboxComponents,
  isDisabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  layout: PropTypes.oneOf(directions.HORIZONTAL_VERTICAL),
  onChange: PropTypes.func.isRequired,
  // will override any child's onChange handler
  selectedValues: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  // will override any child's isChecked or isOn prop - must match value prop of checkboxes
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    type: PropTypes.oneOf(CHECKBOX_TYPES),
    description: PropTypes.string,
    isDisabled: PropTypes.bool
  })),
  label: PropTypes.string,
  id: PropTypes.string,
  spacing: PropTypes.oneOf(sizes.S_M_L),
  gutterSize: PropTypes.oneOf(sizes.S_M_L)
};
CheckboxGroup.defaultProps = {
  children: null,
  isDisabled: false,
  layout: directions.VERTICAL,
  selectedValues: [],
  options: [],
  label: null,
  id: undefined,
  spacing: sizes.MEDIUM,
  gutterSize: sizes.MEDIUM
};

function extractControlsFromChildren(props, onChange) {
  var _context3;

  return _mapInstanceProperty(_context3 = React.Children).call(_context3, props.children, function (input) {
    var isDisabled = isComponentDisabled(props.isDisabled) || isComponentDisabled(input.props.isDisabled);

    if (Utils.isType([Checkbox, PrivateCheckbox], input)) {
      return /*#__PURE__*/React.cloneElement(input, {
        id: input.props.id || props.id,
        onChange: onChange,
        isChecked: _includesInstanceProperty(_).call(_, props.selectedValues, input.props.value),
        isDisabled: isDisabled,
        gutterSize: input.props.gutterSize !== undefined ? input.props.gutterSize : props.gutterSize
      });
    } else {
      return /*#__PURE__*/React.cloneElement(input, {
        id: input.props.id || props.id,
        onChange: onChange,
        isOn: _includesInstanceProperty(_).call(_, props.selectedValues, input.props.value),
        isDisabled: isDisabled,
        gutterSize: props.gutterSize
      });
    }
  });
}

function extractControlsFromOptions(props, onChange) {
  var Component, isChecked;
  var componentIsDisabled = isComponentDisabled(props.isDisabled);
  return _mapInstanceProperty(_).call(_, props.options, function (option) {
    switch (option.type) {
      case 'Checkbox':
        Component = Checkbox;
        isChecked = 'isChecked';
        break;

      case 'Toggle':
        Component = Toggle;
        isChecked = 'isOn';
        break;

      default:
        Component = Checkbox;
        isChecked = 'isChecked';
    }

    return /*#__PURE__*/React.createElement(Component, {
      isChecked: _includesInstanceProperty(_).call(_, props.selectedValues, option.value),
      value: option.value,
      id: option.id || props.id,
      onChange: onChange,
      label: option.label,
      isDisabled: componentIsDisabled || isComponentDisabled(option.isDisabled),
      description: option.description,
      gutterSize: props.gutterSize
    });
  });
}

function checkboxComponents(props) {
  var _context4;

  var warning;

  _forEachInstanceProperty(_context4 = React.Children).call(_context4, props.children, function (input) {
    warning = logger.warn('Invalid component supplied to `CheckboxGroup` children, expected Checkbox, or Toggle', !Utils.isType([Checkbox, PrivateCheckbox, Toggle], input));
  });

  return warning;
}

export var PrivateCheckboxGroup = CheckboxGroup;
export default compose(removeProps(['layout']), whitelistStyles())(CheckboxGroup);
//# sourceMappingURL=index.js.map